import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const successToastify = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
  });
};

export const errorToastify = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    draggable: true,
    closeOnClick: true,
  });
};
